module.exports = __webpack_public_path__ + "static/media/creative-agency-min.cad155f6.png";